// src/services/instances/stage.ts
//
// Cliente HTTP para o domínio de Stages (fases) e StageTeams.

import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';

import {
  GetStageResponse,
  GetStageByIdResponse,
  PostStagesBatchResponse,
  PutStageResponse,
  PutStageCurrentRoundResponse,
  PutStageMainWidgetResponse,
  GetStageTeamsResponse,
  PostStageTeamResponse,
  PostStageBatchTeamsResponse,
} from '../response/stage';

import {
  PostStagesBatchRequest,
  PutStageRequest,
  PutStageCurrentRoundRequest,
  PostStageTeamRequest,
  PostStageBatchTeamsRequest,
} from '../request/stage';

export class StageService {
  /** GET /stages — lista paginada (filtros via QueryParams). */
  static getStages(params?: QueryParams) {
    return apiClient.get<GetStageResponse>(buildApiUrl('/api/v1/competitions/stages'), params);
  }

  /** GET /stages/:id — detalhe. */
  static getStageById(id: string) {
    return apiClient.get<GetStageByIdResponse>(buildApiUrl('/api/v1/competitions/stages/:id', { id }), undefined);
  }

  /** POST /stages/batch — cria N fases em uma transação. */
  static postStagesBatch(data: PostStagesBatchRequest) {
    return apiClient.post<PostStagesBatchResponse>(buildApiUrl('/api/v1/competitions/stages/batch'), data);
  }

  /** PUT /stages/:id — atualiza todos os campos editáveis. */
  static putStage(id: string, data: PutStageRequest) {
    return apiClient.update<PutStageResponse>(buildApiUrl('/api/v1/competitions/stages/:id', { id }), data);
  }

  /** PUT /stages/:id/current-round. */
  static putStageCurrentRound(id: string, data: PutStageCurrentRoundRequest) {
    return apiClient.update<PutStageCurrentRoundResponse>(
      buildApiUrl('/api/v1/competitions/stages/:id/current-round', { id }),
      data,
    );
  }

  /** PUT /stages/:id/main-widget — sem body. */
  static putStageMainWidget(id: string) {
    return apiClient.update<PutStageMainWidgetResponse>(
      buildApiUrl('/api/v1/competitions/stages/:id/main-widget', { id }),
      undefined,
    );
  }

  /** DELETE /stages/:id. */
  static deleteStage(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/competitions/stages/:id', { id }), undefined);
  }

  /** GET /stages/:id/teams — times da fase (paginado). */
  static getStageTeams(id: string, params?: QueryParams) {
    return apiClient.get<GetStageTeamsResponse>(buildApiUrl('/api/v1/competitions/stages/:id/teams', { id }), params);
  }

  /** POST /stages/:id/teams — associa um time. */
  static postStageTeam(id: string, data: PostStageTeamRequest) {
    return apiClient.post<PostStageTeamResponse>(buildApiUrl('/api/v1/competitions/stages/:id/teams', { id }), data);
  }

  /** POST /stages/:id/teams/batch — associa vários times. */
  static postStageBatchTeams(id: string, data: PostStageBatchTeamsRequest) {
    return apiClient.post<PostStageBatchTeamsResponse>(
      buildApiUrl('/api/v1/competitions/stages/:id/teams/batch', { id }),
      data,
    );
  }

  /** DELETE /stage-teams/:uuid — remove a associação de um time com uma fase. */
  static deleteStageTeam(uuid: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/competitions/stage-teams/:uuid', { uuid }), undefined);
  }
}
